import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

interface IPageHeaderProps {
    text: string;
}

export function PageHeader(props: IPageHeaderProps) {
    const { text } = props;

    const muiStyles = makeStyles({
        container: { width: '100%' },
        text: { fontSize: '1.5rem' }
    });

    const { container } = muiStyles(props);

    return (
        <Grid
            className={container}
            container
        >
            <Box>
                <Typography className={text}>
                    {text}
                </Typography>
            </Box>
        </Grid>
    );
}

PageHeader.defaultProps = { text: '---' } as Partial<IPageHeaderProps>;

export default PageHeader;